import ApiService from '@/service'
import { moduleActionContext } from '@/vuex'
import { defineActions, defineModule, defineMutations } from 'direct-vuex'

export const labelsActionContext = (context: any) => moduleActionContext(context, labelsModule)

interface LabelsState {
  existingLabels: string[]
}

const labelsModule = defineModule({
  namespaced: true,
  state: {
    existingLabels: [],
  } as LabelsState,

  mutations: defineMutations<LabelsState>()({
    SET_EXISTING_LABELS(state: LabelsState, labels: string[]) {
      state.existingLabels = labels
    },
  }),

  actions: defineActions({
    async GET_EXISTING_LABELS(ctx): Promise<string[]> {
      const { commit } = labelsActionContext(ctx)
      const { data: results } = await ApiService.getAllLabels()
      commit.SET_EXISTING_LABELS(results)
      return results
    },
  }),
})

export default labelsModule
